import { Pipe, PipeTransform } from '@angular/core';
import { SortDirection } from '@angular/material/sort';
import { compare } from 'src/app/globals';

@Pipe({
  name: 'sortedObjectArray'
})
export class SortedObjectArrayPipe implements PipeTransform {

  transform(value: any[], active: string, direction: SortDirection, counter: number): { key: number, value: any }[] {
    if(!Array.isArray(value)) return [];
    let output = [];
    var index = 0;
    let sequence = value
      .map((value, index) => { return { index: index, value: value[active]} })
      .sort((a, b) => compare(a.value, b.value, direction === 'asc'));
    for(let entry of sequence){
      output.push({ key: index, value: value[entry.index] });
      index++;
    }
    return output;
  }

}
